import { useTranslations } from '@vocab/react';
import { Button, Stack, Text } from 'braid-design-system';

import type { AnalyticsVerificationsWidgetCallToAction } from 'src/modules/analytics/types';

import { useVerificationDialog } from '../VerificationDialogs/useVerificationDialog';
import { verifiableNudgeCredentialTypenameToCallToAction } from '../analyticsUtils';
import type {
  VerifiableNudgeCredentialTypename,
  VerificationsNudgeVerifiableCredential,
} from '../types';

import translations from './.vocab';

interface NudgeProps {
  credential: VerificationsNudgeVerifiableCredential;
  analyticsOnClick: (props: {
    callToAction: AnalyticsVerificationsWidgetCallToAction;
  }) => void;
}

export const SeekPassDialogNudge = ({
  credential,
  analyticsOnClick,
}: NudgeProps) => {
  const { t } = useTranslations(translations);

  const { __typename, url } = credential;

  const verificationToNudgeButtonText: Record<
    VerifiableNudgeCredentialTypename,
    string
  > = {
    IdentityVerifiableCredential: t('Verify your identity'),
    WorkplaceVerifiableCredential: t('Verify your workplace'),
  };

  const { dialog, setShowDialog } = useVerificationDialog({
    typename: __typename,
    url,
    origin: 'nudge',
  });

  const onClick = () => {
    const callToAction =
      verifiableNudgeCredentialTypenameToCallToAction[__typename];
    analyticsOnClick({
      callToAction,
    });

    setShowDialog(true);
  };

  return (
    <>
      <Stack space="medium">
        <Text tone="secondary">
          {t('Profiles with verifications are more likely to be selected.')}
        </Text>
        <Button
          onClick={onClick}
          data={{
            automation: 'verifications-card-nudge-verify-button',
          }}
        >
          {verificationToNudgeButtonText[__typename]}
        </Button>
      </Stack>
      {dialog}
    </>
  );
};
